import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, ChevronRight } from 'lucide-react';

export const ShirtPromoBadge = () => {
  return (
    <Link
      to="/galerie"
      className="group block mx-4 sm:mx-auto max-w-5xl mt-4"
      data-testid="shirt-promo-badge"
    >
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-gray-900 via-slate-900 to-gray-900 shadow-2xl ring-2 ring-amber-400/60 hover:ring-amber-400 transition-all duration-300 hover:scale-[1.01]">
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-[linear-gradient(110deg,transparent_40%,rgba(251,191,36,0.15)_50%,transparent_60%)] bg-[length:200%_100%] animate-[shimmer_3s_linear_infinite]" aria-hidden="true"></div>

        <div className="relative flex items-center gap-3 sm:gap-5 px-4 sm:px-6 py-4">
          {/* Blinking gold dot */}
          <div className="relative flex-shrink-0">
            <span className="absolute inline-flex h-4 w-4 rounded-full bg-amber-400 opacity-75 animate-ping"></span>
            <span className="relative inline-flex rounded-full h-4 w-4 bg-amber-400"></span>
          </div>

          <Crown className="h-7 w-7 sm:h-8 sm:w-8 text-amber-400 flex-shrink-0 animate-pulse" />

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-amber-400 text-gray-900 px-2 py-0.5 rounded text-xs font-black uppercase tracking-wider">
                Offre exclusive
              </span>
              <span className="text-white font-black text-base sm:text-xl tracking-wide">
                5 chemises pour le prix de 4
              </span>
            </div>
            <p className="text-amber-100 text-xs sm:text-sm mt-0.5 font-medium">
              La 5<sup>ème</sup> chemise <span className="text-amber-300 font-bold">OFFERTE</span> dans nos 2 pressings AQUABLUENET. Repassage haut de gamme, cols nets, plis parfaits.
            </p>
          </div>

          <ChevronRight className="h-6 w-6 sm:h-8 sm:w-8 text-amber-400 flex-shrink-0 group-hover:translate-x-1 transition-transform duration-300" />
        </div>
      </div>
    </Link>
  );
};
